
import { Vue, Component } from "vue-property-decorator";
import UnterrichtWidgetForm from "@/views/UnterrichtDashboard/Configuration/UnterrichtWidgetForm.vue";

@Component({
  components: { UnterrichtWidgetForm },
})
export default class UnterrichtConfiguration extends Vue {
  public name = "UnterrichtConfiguration";
}
